import { gql } from '@apollo/client';
import { loader } from 'graphql.macro';
import { TCE_VALUE_FRAGMENT } from './tceValueFragment';

const FRAGMENT = loader('./tcePartFragment.gql');

export const TCE_PART_TYPE_NAME = 'TcePart';
export const TCE_PART_FRAGMENT_NAME = 'TcePartFragment';
export const TCE_PART_FRAGMENT = gql`
    ${FRAGMENT}
    ${TCE_VALUE_FRAGMENT}
`;
